<template>
    <div id="main-wrapper">
        <NavbarDark />

            <!-- Loading -->
            <div v-if="loading" class="text-center py-5">
                <span>{{ $t('Downloading..') }}</span>
            </div>

            <!-- Error -->
            <div v-else-if="error" class="container py-5">
                <div class="alert alert-danger">
                    {{ error }}
                </div>
            </div>

            <template v-else-if="company">
                <div
                    class="company-header"
                    :style="{
                        backgroundImage: `url(${company.cover_image})`
                    }"
                >
                    <div class="overlay"></div>
                    <div class="content">
                        <img
                            v-if="company.profile_image"
                            :src="company.profile_image"
                            :alt="company.name"
                            class="company-logo"
                        />
                    </div>
                </div>


                <div class="container">
                    <div class="card border-0 shadow-sm rounded-3 mb-5 company-definition">
                        <div class="card-body p-4 p-md-5">

                            <div class="text-center">

                                <h2 class="mb-3 fw-semibold">
                                    {{ company.name }}
                                </h2>
                                <p class="text-muted mb-0 lh-lg">
                                    {{ company.definition }}
                                </p>

                            </div>

                        </div>
                    </div>
                    
                    <!-- Current Exhibitions -->
                    <section class="mb-5">
                        <div class="d-flex align-items-center justify-content-between mb-4">
                            <h3 class="fw-semibold mb-0">{{ $t('Current Exhibitions') }}</h3>
                            <span class="badge bg-primary">{{ company.current_exhibits?.length || 0 }}</span>
                        </div>

                        <div
                            v-if="!company.current_exhibits?.length"
                            class="card border-0 shadow-sm rounded-3"
                        >
                            <div class="card-body text-center py-5">
                                <p class="text-muted mb-0">
                                    {{ $t('There are no current exhibitions.') }}
                                </p>
                            </div>
                        </div>

                        <div v-else class="row g-4">
                            <div v-for="(item, index) in company.current_exhibits" :key="index" class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <div class="card border-0 rounded-4 h-100 position-relative">
                                    <router-link :to="`/${locale}/exhibit/${item.slug}`">
                                        <div class="abx-thumb" data-overlay="3">
                                            <img :src="`${item.logo}`" class="img-fluid" alt="exhibit-image">
                                        </div>
                                    </router-link>

                                    <div class="position-absolute top-0 start-0 w-100 p-3">
                                        <div class="d-flex justify-content-between align-items-stretch">
                                            <div class="d-flex flex-column text-start">
                                                <div class="label1 bg-primary text-light px-2 d-flex align-items-center">{{ item.city_name || 'Unknown City' }}</div>
                                                <div class="label1 bg-primary text-light px-2 d-flex align-items-center mt-1 ">{{ getExhibitStatus(item) }}</div>
                                            </div>
                                            <div class="d-flex flex-column text-end">
                                                <div class="label1 bg-primary text-light px-2 d-flex align-items-center">{{ item.start_date || 'Unknown start date' }}</div>
                                                <div class="label1 bg-primary text-light px-2 mt-1">{{ item.end_date || 'Unknown end date' }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="position-absolute bottom-0 start-50 translate-middle-x w-100 text-center mb-3">
                                        <div class="label1 bg-primary text-light px-2">{{ item.name || 'Unknown exhibit name' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>


                    <!-- Ended Exhibitions -->
                    <section class="mb-5">
                        <div class="d-flex align-items-center justify-content-between mb-4">
                            <h3 class="fw-semibold mb-0">{{ $t('Ended Exhibitions') }}</h3>
                            <span class="badge bg-secondary">{{ company.ended_exhibits?.length || 0 }}</span>
                        </div>
                        <div
                            v-if="!company.ended_exhibits?.length"
                            class="card border-0 shadow-sm rounded-3"
                        >
                            <div class="card-body text-center py-5">
                                <p class="text-muted mb-0">
                                    {{ $t('There are no ended exhibitions.') }}
                                </p>
                            </div>
                        </div>

                        <div v-else class="row g-4">
                            <div v-for="(item, index) in company.ended_exhibits" :key="index" class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                                <div class="card border-0 rounded-4 h-100 position-relative">
                                    <router-link :to="`/${locale}/exhibit/${item.slug}`">
                                        <div class="abx-thumb" data-overlay="3">
                                            <img :src="`${item.logo}`" class="img-fluid" alt="exhibit-image">
                                        </div>
                                    </router-link>

                                    <div class="position-absolute top-0 start-0 w-100 p-3">
                                        <div class="d-flex justify-content-between align-items-stretch">
                                            <div class="d-flex flex-column text-start">
                                                <div class="label1 bg-primary text-light px-2 d-flex align-items-center">{{ item.city_name || 'Unknown City' }}</div>
                                                <div class="label1 bg-primary text-light px-2 d-flex align-items-center mt-1 ">{{ getExhibitStatus(item) }}</div>
                                            </div>
                                            <div class="d-flex flex-column text-end">
                                                <div class="label1 bg-primary text-light px-2 d-flex align-items-center">{{ item.start_date || 'Unknown start date' }}</div>
                                                <div class="label1 bg-primary text-light px-2 mt-1">{{ item.end_date || 'Unknown end date' }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="position-absolute bottom-0 start-50 translate-middle-x w-100 text-center mb-3">
                                        <div class="label1 bg-primary text-light px-2">{{ item.name || 'Unknown exhibit name' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </template>

        <FooterTop :bg="'theme-bg'" />
        <FooterDark />
        <ScrollToTop />

    </div>
</template>


<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import axios from 'axios';

import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import NavbarDark from '@/components/navbar/navbar-dark.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';


const route = useRoute();
const router = useRouter();

const { t,locale } = useI18n();

const company = ref(null);
const loading = ref(false);
const error = ref(null);
const fetchCompany = async (slug = route.params.slug) => {
    if (!slug) { return;}
    loading.value = true;
    error.value = null;
    try {
        const response = await axios.get(`/companies/${slug}`,
            {
                headers: {
                    locale: locale.value
                }
            }
        );
        if (response.data.success) {
            company.value = response.data.data;
        } else {
            company.value = null;
            go404();
        }

    } catch (err) {
        console.error('Error fetching company:', err);
        company.value = null;
        if (err.response?.status === 404) {
            go404();
        }
        error.value =
            err.response?.data?.message ||
            'Failed to load company data.';
    } finally {
        loading.value = false;
    }
};

const go404 = () => {
    if (route.name === "not-found") return;

    router.replace({
        name: "NotFound",
        params: { lang: route.params.lang },
    });
};

onMounted(() => {
    fetchCompany();
});


watch(
    () => route.params.slug,
    fetchCompany,
    { immediate: true }
);

watch(
    () => route.params.lang,
    (newLang) => {
        if (!company.value) return;

        const newSlug = company.value.slug?.[newLang];

        if (!newSlug) {
            go404();
            return;
        }

        router.replace({
            name: "CompanyDetail",
            params: {
                lang: newLang,
                slug: newSlug,
            },
        });
    }
);

const parseLocalDate = (dateStr) => {
  const [year, month, day] = dateStr.split('-');
  return new Date(year, month - 1, day);
};

const getExhibitStatus = (item) => {
  if (!item.start_date || !item.end_date) return t('Unknown');

  const now = new Date();

  const start = parseLocalDate(item.start_date);
  start.setHours(0, 0, 0, 0);

  const end = parseLocalDate(item.end_date);
  end.setHours(23, 59, 59, 999); 

  if (now >= start && now <= end) return t('Active');
  if (now < start) return t('Soon');
  if (now > end) return t('Finished');
  return t('Unknown');
};
</script>


<style scoped>
.company-header {
    position: relative;
    width: 100%;
    height: 420px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
}

.content {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
}

.company-logo {
    width: 160px;
    height: 160px;
    object-fit: cover;
    border-radius: 50%;
    background: #fff;
    padding: 7px;
    box-shadow: 0 10px 35px rgba(0, 0, 0, 0.25);
}

.company-definition {
    margin-top: -50px;
    position: relative;
    z-index: 5;
}

@media (max-width: 768px) {
    .company-header {
        height: 280px;
    }
    .company-logo {
        width: 120px;
        height: 120px;
    }
    .company-definition {
        margin-top: -35px;
    }
}
</style>
